import { CheckoutFrameContext } from 'app/context/CheckoutFrameContext';
import { ShippingContactContext } from 'app/context/ShippingContactContext';
import { getXprops } from 'app/helpers/getXprops';
import { parseShippingFormDataForEndpoint } from 'app/pages/frames/components/Form/FormShipping/helpers';
import { IShippingContact } from 'app/pages/frames/components/Form/FormShipping/interface';
import { useCreditCardSubtmitOrder } from 'app/pages/frames/hooks/creditCardSubmitOrder';
import { useHandleCard } from 'app/pages/frames/hooks/handleCard';
import { PaymentMethodType } from 'app/util/constants';
import { useContext, useEffect, useState } from 'react';

export const useCardOrder = () => {
  const [error, setError] = useState<any>();
  const [isLoading, setIsLoading] = useState<any>(false);
  const [confirmationShippingContact, setConfirmationShippingContact] = useState<any>(false);
  const [initialTime] = useState(new Date());

  const { checkoutRequest } = useContext(CheckoutFrameContext);
  const { needsShippingContact = false, recurrent: isRecurrent = false } = checkoutRequest;
  const { setShowShippingForm } = useContext(ShippingContactContext);

  const { action, error: errorHandleCard } = useHandleCard();
  const { error: errorCreateOrder, doPost, data, threeDsFlag } = useCreditCardSubtmitOrder();
  const {
    config: { checkoutRequestId },
  } = getXprops();

  useEffect(() => {
    if (errorHandleCard || errorCreateOrder) {
      setError(errorHandleCard || errorCreateOrder);
    }
  }, [errorHandleCard, errorCreateOrder]);

  const onSubmit = async (values: any) => {
    try {
      const { cardExpMonthYear, ...restValues } = values;
      const cardExpValues = cardExpMonthYear.split('/');
      const formCardValues = {
        cardExpMonth: cardExpValues[0],
        cardExpYear: cardExpValues[1],
        ...restValues,
      };
      if (needsShippingContact && !values?.shippingContact) {
        setShowShippingForm(true);
        return;
      }
      setIsLoading(true);
      const { token, shippingContact, binNumber, ...rest } = await action(formCardValues);

      const customBody = {
        checkoutRequestId,
        paymentMethod: PaymentMethodType.Card,
        tokenId: token.id,
        shippingContact,
        ...rest,
      };
      if (needsShippingContact && customBody.shippingContact) {
        const shippingContactTemp: IShippingContact = parseShippingFormDataForEndpoint(customBody.shippingContact);
        customBody.shippingContact = { ...shippingContactTemp };
        setConfirmationShippingContact(shippingContact);
      }

      await doPost({
        paymentRequestData: customBody,
        initialTime,
        binNumber,
        formCard: formCardValues,
      });
    } catch (e: any) {
      setError(e);
    } finally {
      setIsLoading(false);
    }
  };
  return {
    action: onSubmit,
    data: {
      ...data,
      confirmationShippingContact,
    },
    error,
    threeDsFlag,
    isRecurrent,
    isLoading,
  };
};
